import React from 'react';
import { Link } from 'react-router-dom';
export function ServicesSection() {
  return <section id="services" className="w-full py-20 px-4 sm:px-6 lg:px-8" style={{
    background: '#111111'
  }} data-id="element-403">
      <div className="max-w-7xl mx-auto" data-id="element-404">
        {/* Heading */}
        <div className="text-center mb-14" data-id="element-405">
          <p className="text-xs font-bold uppercase mb-3" style={{
          color: '#CC0000',
          letterSpacing: '0.2em'
        }} data-id="element-406">
            What We Do
          </p>
          <h2 className="font-black text-white text-4xl sm:text-5xl" data-id="element-407">
            Expert Tire Services
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1" data-id="element-408">
          {/* Card 1 — Tire Sales */}
          <Link to="/services/tire-sales" className="relative overflow-hidden group cursor-pointer block" style={{
          minHeight: '320px'
        }} data-id="element-409">
            <img src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=600&q=80" alt="Tire Sales" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-410" />
            <div className="absolute inset-0 transition-all duration-500" style={{
            background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.10) 100%)'
          }} data-id="element-411" />
            <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-412">
              <p className="text-xs font-bold uppercase mb-2" style={{
              color: '#FECB00',
              letterSpacing: '0.15em'
            }} data-id="element-413">
                Tire Sales
              </p>
              <h3 className="font-black text-white text-xl leading-tight" data-id="element-414">
                Top Brands for Every Vehicle
              </h3>
              <p className="text-white/70 text-sm mt-3 group-hover:text-white transition-colors duration-300" data-id="element-415">
                View Service →
              </p>
            </div>
          </Link>

          {/* Card 2 — Tire Installation */}
          <Link to="/services/tire-installation" className="relative overflow-hidden group cursor-pointer block" style={{
          minHeight: '320px'
        }} data-id="element-416">
            <img src="https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=600&q=80" alt="Tire Installation" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-417" />
            <div className="absolute inset-0 transition-all duration-500" style={{
            background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.10) 100%)'
          }} data-id="element-418" />
            <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-419">
              <p className="text-xs font-bold uppercase mb-2" style={{
              color: '#FECB00',
              letterSpacing: '0.15em'
            }} data-id="element-420">
                Installation
              </p>
              <h3 className="font-black text-white text-xl leading-tight" data-id="element-421">
                Tire Installation &amp; Balancing
              </h3>
              <p className="text-white/70 text-sm mt-3 group-hover:text-white transition-colors duration-300" data-id="element-422">
                View Service →
              </p>
            </div>
          </Link>

          {/* Card 3 — Tire Rotation */}
          <Link to="/services/tire-rotation" className="relative overflow-hidden group cursor-pointer block" style={{
          minHeight: '320px'
        }} data-id="element-423">
            <img src="https://images.unsplash.com/photo-1531384441138-2736e62e0919?w=600&q=80" alt="Tire Rotation" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-424" />
            <div className="absolute inset-0 transition-all duration-500" style={{
            background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.10) 100%)'
          }} data-id="element-425" />
            <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-426">
              <p className="text-xs font-bold uppercase mb-2" style={{
              color: '#FECB00',
              letterSpacing: '0.15em'
            }} data-id="element-427">
                Maintenance
              </p>
              <h3 className="font-black text-white text-xl leading-tight" data-id="element-428">
                Tire Rotation &amp; Alignment
              </h3>
              <p className="text-white/70 text-sm mt-3 group-hover:text-white transition-colors duration-300" data-id="element-429">
                View Service →
              </p>
            </div>
          </Link>

          {/* Card 4 — Flat Tire Repair */}
          <Link to="/services/flat-tire-repair" className="relative overflow-hidden group cursor-pointer block" style={{
          minHeight: '320px'
        }} data-id="element-430">
            <img src="https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?w=600&q=80" alt="Flat Tire Repair" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-431" />
            <div className="absolute inset-0 transition-all duration-500" style={{
            background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.10) 100%)'
          }} data-id="element-432" />
            <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-433">
              <p className="text-xs font-bold uppercase mb-2" style={{
              color: '#FECB00',
              letterSpacing: '0.15em'
            }} data-id="element-434">
                Repair
              </p>
              <h3 className="font-black text-white text-xl leading-tight" data-id="element-435">
                Flat Tire Repair
              </h3>
              <p className="text-white/70 text-sm mt-3 group-hover:text-white transition-colors duration-300" data-id="element-436">
                View Service →
              </p>
            </div>
          </Link>

          {/* Card 5 — Free Tire Checks */}
          <Link to="/services/free-tire-checks" className="relative overflow-hidden group cursor-pointer block" style={{
          minHeight: '320px'
        }} data-id="element-437">
            <img src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=600&q=80" alt="Free Tire Checks" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-438" />
            <div className="absolute inset-0 transition-all duration-500" style={{
            background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.10) 100%)'
          }} data-id="element-439" />
            <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-440">
              <p className="text-xs font-bold uppercase mb-2" style={{
              color: '#FECB00',
              letterSpacing: '0.15em'
            }} data-id="element-441">
                Free Service
              </p>
              <h3 className="font-black text-white text-xl leading-tight" data-id="element-442">
                Free Tire Checks
              </h3>
              <p className="text-white/70 text-sm mt-3 group-hover:text-white transition-colors duration-300" data-id="element-443">
                View Service →
              </p>
            </div>
          </Link>

          {/* Card 6 — Emergency (red overlay) */}
          <Link to="/services/emergency-roadside" className="relative overflow-hidden group cursor-pointer block" style={{
          minHeight: '320px'
        }} data-id="element-444">
            <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=600&q=80" alt="Emergency Roadside" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-445" />
            <div className="absolute inset-0 transition-all duration-500 group-hover:opacity-70" style={{
            background: 'linear-gradient(to top, rgba(204,0,0,0.92) 0%, rgba(204,0,0,0.55) 60%, rgba(0,0,0,0.20) 100%)'
          }} data-id="element-446" />
            <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-447">
              <p className="text-xs font-bold uppercase mb-2 text-white/80" style={{
              letterSpacing: '0.15em'
            }} data-id="element-448">
                24/7 Emergency
              </p>
              <h3 className="font-black text-white text-xl leading-tight" data-id="element-449">
                Emergency Roadside Assistance
              </h3>
              <p className="text-white/70 text-sm mt-3 group-hover:text-white transition-colors duration-300" data-id="element-450">
                View Service →
              </p>
            </div>
          </Link>
        </div>

        {/* Bottom CTA */}
        <div className="mt-14 text-center" data-id="element-451">
          <Link to="/contact" className="inline-block text-white font-black uppercase tracking-widest px-12 py-5 text-sm transition-colors duration-200" style={{
          background: '#CC0000',
          letterSpacing: '0.15em'
        }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-452">
            Book a Service Appointment
          </Link>
        </div>
      </div>
    </section>;
}